import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { useDateLocale, useTimeZone } from '../../../../hooks'
import { FloatingTooltip } from '../../../Floating'
import Text from '../../../Text'
import {
  formatGretaAIChatTimeAbsolute,
  formatGretaAIChatTimeRelative,
} from '../GretaAIChatMessageActions.utils'

import * as styles from './GretaAIChatMessageTime.module.css'

function GretaAIChatMessageTime({ createdAt, now }) {
  const locale = useDateLocale()
  const timeZone = useTimeZone()

  return createdAt ? (
    <FloatingTooltip
      content={formatGretaAIChatTimeAbsolute(createdAt, locale, timeZone)}
      placement={FLOATING_ELEMENT_PLACEMENT.top}
    >
      <Text isSecondary className={styles.time}>
        {formatGretaAIChatTimeRelative(createdAt, now, locale)}
      </Text>
    </FloatingTooltip>
  ) : null
}

export default GretaAIChatMessageTime
